import { LoginRequestInterface } from '@/data/payload/contracts/AuthRequest'

export class LoginApiRequest implements LoginRequestInterface {
  private email: string
  private password: string

  constructor(email: string, password: string) {
    this.email = email
    this.password = password
  }

  public toJSON() {
    const data = {
      email: this.email,
      password: this.password,
    }

    return JSON.stringify({
      data,
    })
  }
}
